export default __webpack_public_path__ + "static/media/html.0d9cfb6c.png";